const ENVIRONMENTS = {
    PRODUCTION: 'production',
    TEST: 'test',
};

export { ENVIRONMENTS };
//# sourceMappingURL=environments.js.map
